import { useArePeopleVisible } from "@/hooks/useArePeopleVisible";
import { useTeams } from "@/contexts/teams-provider";

/**
 * Whether the selected team can get a person's contact card: it sees its key
 * contacts and keeps at least one reveal channel open (#757, #840). A team
 * without either has no contact card to ask for — the request would only be
 * refused. A channel the stored team does not carry yet reads as open, like
 * `ContactRevealPreviewCard`: the API refuses a cut channel either way.
 */
export function useIsContactRevealOffered(): boolean {
  const { teamSelected } = useTeams();
  const arePeopleVisible = useArePeopleVisible();
  const isAnyChannelEnabled =
    (teamSelected?.featureContactRevealEmailEnabled ?? true) ||
    (teamSelected?.featureContactRevealPhoneEnabled ?? true);
  return arePeopleVisible && isAnyChannelEnabled;
}
